import { z } from "zod";
import { GENRE_VALUES } from "../../constants/genre.js";
import { USER_ROLE_VALUES } from "../../constants/user-role.js";
export const PublicUserSchema = z.object({
    id: z.uuid(),
    email: z.email(),
    displayName: z.string(),
    role: z.enum(USER_ROLE_VALUES),
    level: z.number().int().nonnegative(),
    avatarUrl: z.url().nullable(),
    preferredGenres: z.array(z.enum(GENRE_VALUES)),
    createdAt: z.string(),
});
